
import React, { Fragment } from 'react';
import { Button }from '@cmsgov/design-system';

import parse from 'html-react-parser';
import { FormattedMessage, useIntl } from 'react-intl';


const SaveResultModal = props => {
    
    const {
        actions: {
            hideModal
        },
        boundAnchor,
        modal: {
            modalData: {
                callback,
                saveResult: {
                    errorMessage = '',
                    success,
                    successMessage
                }
            }
        },
        secondaryTopAnchors: [
            anchor_2
        ],
        modalHeaderProps: {
            modalId
        }
    } = props;
    
    const handleClick = () => {
        hideModal();
        if (success) {
            callback();
        }
    };
    
    const intlApi = useIntl();

    const EMAIL_DUPLICATION_ERRORS = [ '101', '102' ];
    const EMAIL_DUPLICATION_FAILURE_ID = 'preferences_page.email_duplication_failure';
    
    return (
        <Fragment>
            <div className="gi-modal__body" id = {modalId}>
                <p id = {successMessage} aria-live="polite">
                    {success ? (
                        <FormattedMessage id={successMessage} />
                    ) : EMAIL_DUPLICATION_ERRORS.includes(errorMessage) ? (
                        <FormattedMessage id={EMAIL_DUPLICATION_FAILURE_ID} />
                    ) : (
                        <FormattedMessage
                            id="preferences_page.save_failed"
                            values={{
                                errorMessage,
                                br: <br />,
                                strong: chunks => <strong>{chunks}</strong>,
                            }}
                        />
                    )}
                </p>
            </div>
            <div className = 'gi-modal__footer' >
                <div className = 'grid-row controls' >
                    <div className = 'grid-offset-6 txt-left' >
                        <Button
                            className="usa-button gi-button gi-button__primary"
                            onClick={handleClick}
                            inputRef={boundAnchor(anchor_2)}
                            aria-labelledby={successMessage}
                        >
                            <FormattedMessage id = 'button.ok' />
                        </Button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default SaveResultModal;